import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { deleteJob } from '../../repositories/HttpRepository';
import { StyledTableCell, StyledTableRow, useStyles } from './styles';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { jobClientInfo, jobInfoSelector, timestampState } from './states';

export default function JobInfo() {
  const { classes } = useStyles();
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const { id } = useParams();
  let history = useNavigate();

  const jobInfo = useRecoilValue(jobInfoSelector(id));
  const client = useRecoilValue(jobClientInfo(id));

  const setTimestamp = useSetRecoilState(timestampState);
  const handleClose = () => {
    navigate('/jobs');
  };

  const doDeleteJob = (job) => () => {
    setDeleting(true);
    deleteJob(job.id).then((resp) => {
      if (resp.ok) {
        setTimestamp(new Date());
        handleClose();
      } else {
        setError(`Error while delete job: ${job.id}`);
      }
    });
  };

  return (
    <Dialog fullWidth maxWidth={'xl'} onClose={handleClose} aria-labelledby="customized-dialog-title" open={true}>
      <DialogTitle id="customized-dialog-title">Delete Job</DialogTitle>
      <DialogContent dividers>
        {jobInfo.job && (
          <Box sx={{ mb: 3 }}>
            <Grid container spacing={3}>
              <Grid size={4}>
                Job ID
                <br />
                <strong>{jobInfo.job.id}</strong>
              </Grid>
              <Grid size={4}>
                Client
                <br />
                <strong>{client?.company}</strong>
              </Grid>
              <Grid size={4}>
                No Of Shipments
                <br />
                <strong>{jobInfo.job.shipment_count}</strong>
              </Grid>
              <Grid size={4}>
                Status
                <br />
                <strong>{jobInfo.job.status}</strong>
              </Grid>
              <Grid size={4}>
                Time
                <br />
                <strong>{jobInfo.job.dropoff_earliest_ts}</strong>
              </Grid>
            </Grid>
            <Divider />
          </Box>
        )}
        {error && <Alert severity="error">{error}</Alert>}
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>ID</StyledTableCell>
                <StyledTableCell>Label</StyledTableCell>
                <StyledTableCell>Driver ID</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>No Of shipments</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {jobInfo?.info &&
                jobInfo.info.length > 0 &&
                jobInfo.info.map((route) => (
                  <StyledTableRow key={route.id}>
                    <StyledTableCell component="th" scope="row">
                      {route.id}
                    </StyledTableCell>
                    <StyledTableCell>{route.label}</StyledTableCell>
                    <StyledTableCell>{route.driver_id}</StyledTableCell>
                    <StyledTableCell>{route.status}</StyledTableCell>
                    <StyledTableCell>{route.no_of_shipment}</StyledTableCell>
                    <StyledTableCell>{route.total_shipment}</StyledTableCell>
                  </StyledTableRow>
                ))}
              {(!jobInfo?.info || jobInfo.info.length <= 0) && (
                <StyledTableRow>
                  <StyledTableCell align="center" colSpan={8}>
                    No Route, you can easier to delete this job!
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Box sx={{ padding: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DeleteIcon />}
            onClick={
              jobInfo?.job
                ? doDeleteJob(jobInfo.job)
                : () => {
                    // console.log('Cannot load job');
                  }
            }
          >
            Delete
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
